module.exports = __webpack_public_path__ + "img/logo.ea7aacb5.svg";